export type CallFlow = 'DEFAULT' | 'CUSTOM' | 'EXTERNAL' | 'CUSTOM_NEW_FLOW';

export interface ITwilioPhone {
  id: number;
  tw_phone_id: string;
  phone: string;
  call_flow: CallFlow;
  forward_to: string | null;
  location_id: number | null;
  location_name: string | null;
  department_id: number | null;
  department_name_resolved: string | null;
  active: number;
  forward_count: number;
}

export type CheckStatus = 'active' | 'sid_changed' | 'released' | 'not_found';

export interface ITwilioCheckResult {
  status: CheckStatus;
  message: string;
  sid?: string;
  old_sid?: string;
  new_sid?: string;
  phone?: string;
}

export interface ITwilioPhoneResponse {
  data: ITwilioPhone[];
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

export class TwilioPhone {
  id: number;
  phone: string;
  callFlow: CallFlow;
  forwardTo: string | null;
  locationId: number | null;
  locationName: string | null;
  departmentId: number | null;
  departmentName: string | null;
  active: boolean;

  twPhoneId: string;
  forwardCount: number;

  constructor(d: ITwilioPhone) {
    this.id = d.id;
    this.twPhoneId = d.tw_phone_id;
    this.phone = d.phone;
    this.callFlow = d.call_flow;
    this.forwardTo = d.forward_to;
    this.locationId = d.location_id;
    this.locationName = d.location_name;
    this.departmentId = d.department_id;
    this.departmentName = d.department_name_resolved;
    this.active = d.active === 1;
    this.forwardCount = d.forward_count ?? 0;
  }

  friendly(): string {
    const digits = this.phone.replace(/\D/g, '').slice(-10);
    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return this.phone;
  }

  isCustomFlow(): boolean {
    return this.callFlow === 'CUSTOM' || this.callFlow === 'CUSTOM_NEW_FLOW';
  }
}
